import { transport } from 'config/transport';

export function callApiGetAllThuChiBanNganh(academicYear) {
    return transport.get(`/bannganh/thuchi`, { params: { academicYear } });
}
